var React = require('react');

function TagBestseller (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"tag_bestseller","d":"M8.127,12.584,11.24,9.471l.915-.884h0l.67-.67A2.207,2.207,0,1,0,9.7,4.8L8.143,6.358l0,0h0L6.565,4.782A2.207,2.207,0,0,0,3.444,7.9l1.6,1.6h0Z","transform":"translate(-2.797 -4.135)","fill":"#fff","fillRule":"evenodd"}));
}

TagBestseller.defaultProps = {"width":"10.675","height":"8.449","viewBox":"0 0 10.675 8.449"};

module.exports = TagBestseller;

TagBestseller.default = TagBestseller;
